export default __webpack_public_path__ + "static/media/cow2.168912bf.png";